'use strict';

import $ from 'jquery';
import Link from '../_modules/link/link';
import Vivus from 'vivus';
import Ladda from 'ladda';

var _animCallbacks = {
	onLogoLoad: (id) => {
  	window.requestAnimationFrame(() => { $('#' + id).addClass('filled'); });
	}
};

$(() => {
  new Link();

  // Clear render stages
  for (var img of $('.animated-svg > img')) {
  	let id = "anim-svg-" + Math.floor(Math.random() * 10000000000000);
  	let parent = $(img).parent();
  	parent.attr('id', id);
  	let attrs = { 
	  	duration: $(img).data('duration') ? parseInt($(img).data('duration')) : 200,
	  	type: $(img).data('type'),
	  	start: $(img).data('start'),
	    animTimingFunction: Vivus[$(img).data('anim')],
	  	file: img.src,
	  	callback: _animCallbacks[$(img).data('callback')]
	  };
	  parent.html('');
	  new Vivus(id, attrs, typeof attrs.callback === "function" ? () => { attrs.callback(id) } : null);
  }

  setInterval(() => {
    $(".blinker").toggleClass('out');
  }, 600)

  setTimeout(() => {
  	$(".landing-browser-content > img").addClass('scrolling');
  }, 2350);

  for (var form of $('form.landing-cta')) {
  	let $form = $(form);
  	let $submitBtn = $form.find('.btn');
  	let submitBtn = Ladda.create($submitBtn.get(0));
  	let submitted = false;

  	function handleErr(err) {
  		$form.find('.help-block').removeClass('fadeInDown').html(err).addClass('fadeInDown'); 
  		submitBtn.stop();
  	}
  	$form.submit(() => {
  		if(submitted) return;
  		submitBtn.start();
  		$.ajax({
        type: $form.attr('method'),
        url: $form.attr('action'),
        data: $form.serialize(),
        cache: false,
        dataType: 'json',
        contentType: "application/json; charset=utf-8",
        error: (err) => handleErr(err.toString()),
        success: (data) => {
          if (data.result != "success") {
        		handleErr(data.msg);
          } else {
          	submitted = true;
            $form.find('.landing-cta-email').prop("disabled", true).val('You will receive an email shortly.');
            handleErr('');
  					submitBtn.stop();
            $submitBtn.addClass('btn-success').prop("disabled", true).text('Thank You');
          }
        }
    	});
  		return false;
  	})
  }

	let tour_items = [{
		img: '/images/fossa-preview.png',
		description: 'Keep simple, plain-english to-do lists of your licensing obligations and issues.',
		hotspots: [{
			x: 9,
			y: 44,
			title: 'Issue Alerts',
			text: 'FOSSA finds and flags issues throughout your dep tree'
		}, {
			x: 30,
			y: 75,
			title: 'Plain-English Obligations',
			text: 'Obligations are collected from hundreds of license files across your Open Source & assembled in plain english -- linked directly to their location'
		}, {
			x: 60,
			y: 55,
			title: 'License & Deep Dependency Lists',
			text: 'List all deep dependencies & license texts, plain-english summaries & file matches'
		}]
	}, {
		img: '/images/fossa-workflow-preview.png',
		description: 'Fix issues that FOSSA finds with smart suggestions that flow into your current workflow.',
		hotspots: [{
			x: 11,
			y: 10,
			title: 'Workflow Status Tracking',
			text: 'FOSSA tracks the status of your issues and automatically resolves when fixed'
		}, {
			x: 48,
			y: 27,
			title: 'Issue Tracker Export',
			text: 'Issues can be exported directly into tickets within systems like JIRA and then tracked for updates'
		}, {
			x: 75,
			y: 15,
			title: 'Context-Aware Suggestions',
			text: 'Smart suggestions built from understanding the impact of modules in your codebase'
		}, {
			x: 75,
			y: 45,
			title: 'Relationship Analysis',
			text: 'FOSSA understands how modules are included to help engineering decisions'
		}, {
			x: 75,
			y: 75,
			title: 'Audit Logs',
			text: 'All changes are tracked with the who and when'
		}]
	}, {
		img: '/images/fossa-policy-preview.png',
		description: 'Policies are like firewalls for your code, keeping certain licenses and terms out.<br/>FOSSA ships with default templates vetted by Open Source compliance experts.',
		hotspots: [{
			x: 50,
			y: 50,
			title: 'Vetted Policy Templates',
			text: 'Default, editable templates for common use cases are included in every copy of FOSSA, vetted by lawyers and experts.'
		}, {
			x: 32,
			y: 31,
			title: 'Adding Rules',
			text: 'Policies let you keep things out of your code -- from licenses, groups of licenses (i.e. Copyleft), specific libraries or even individual terms (i.e. "Disclose Source").'
		}]
	}, {
		img: '/images/fossa-bom-preview.png',
		description: 'One click to generate thorough Bill-of-Materials and attribution files with raw copyright headers and license texts.',
		hotspots: [{
			x: 75,
			y: 55,
			title: 'Raw License Data',
			text: 'Raw license headers and texts are used, so even the small modifications are preserved'
		}, {
			x: 10,
			y: 15,
			title: 'HTML & Markdown Export',
			text: 'Export to both HTML and Markdown to host attribution online, on GitHub, or inside of a view in your application.'
		}, {
			x: 35,
			y: 25,
			title: 'Up-to-date Attribution',
			text: 'Attribution is versioned and you will be alerted when files are out-of-date'
		}, {
			x: 10,
			y: 35,
			title: 'All-inclusive',
			text: 'These files contain all direct and deeper dependencies, with full license texts included at the bottom'
		}] // direct and deeper deps, watch for attribution updates
	}];

  let $tourStage = $('.landing-tour-content');
  
  if($tourStage) {
		window.tour_index = 0;
	  window.renderTourItem = function() {
		  $('.landing-tour .landing-section-navigation .active').removeClass('active');
		  $($('.landing-tour .landing-section-navigation li').get(window.tour_index)).addClass('active');
	  	let _item = tour_items[window.tour_index];
	  	$tourStage.html('<img class="animated fadeIn" src="' + _item.img + '"/>');
	  	for(let i=0; i<_item.hotspots.length; i++) {
	  		let new_hotspot = $('<span class="hotspot"></span>');
	  		new_hotspot.css({
	  			left: _item.hotspots[i].x + '%',
	  			top: _item.hotspots[i].y + '%'
	  		}).on('click', function() {
	  			return false;
	  		});
	  		$tourStage.append(new_hotspot);
	  		if(_item.hotspots[i].title) {
	  			let $hotspot_content = $('<span class="hotspot-content"><h4>' + _item.hotspots[i].title + '</h4><p>' + _item.hotspots[i].text + '</p><span>');
	  			$hotspot_content.css({
		  			left: _item.hotspots[i].x + '%',
		  			top: _item.hotspots[i].y + '%'
		  		});
	  			$tourStage.append($hotspot_content);
	  		}
	  	}
	  	$('.landing-tour .landing-tour-desc').html('* ' + _item.description);
	  };
  	$('.landing-tour-prev').on('click', () => {
  		window.tour_index -= 1;
  		if(window.tour_index < 0) {
  			window.tour_index = tour_items.length - 1;
  		}
  		window.renderTourItem();
  	});
  	$('.landing-tour-next').on('click', () => {
  		window.tour_index += 1;
  		if(window.tour_index >= tour_items.length) {
  			window.tour_index = 0;
  		}
  		window.renderTourItem();
  	});
  	let nav_items = $('.landing-tour > .landing-section-navigation > li');
  	for (let i=0; i<nav_items.length; i++) {
  		$(nav_items[i]).on('click', () => {
	  		window.tour_index = i;
	  		window.renderTourItem();
	  	});
  	}
  	window.renderTourItem();
	}
});
